import styled from 'styled-components';

export const Title = styled.h6`
  font-weight: bold;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  background: ${({ theme }) => theme.pantone656C};
  padding: 1rem;
  border-radius: 8px;
  width: 100%;
`;

export const AreaInputNumber = styled.div`
  position: relative;
`;

export const AreaCheckbox = styled.div`
  position: absolute;
  top: 14px;
  right: 0.6rem;
  margin: 0;

  .MuiFormControlLabel-root {
    margin: 0;
  }

  .MuiCheckbox-root {
    padding: 0;
  }

  .MuiCheckbox-colorSecondary.Mui-checked {
    color: #fab01c;
  }
`;

export const BodyBox = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: background 0.3s ease-out;
  width: 100%;

  &:hover {
    background: ${({ theme }) => theme.hoverGray};
  }
`;

export const ContainerScroll = styled.div`
  max-height: 450px;
  overflow-y: auto;
`;

export const TitleGrid = styled.div`
  font-weight: bold;
  color: #000;
  margin-top: 10px;
`;

export const TitleType = styled.span`
  margin: 0;
  font-size: 13px;
  word-break: break-all;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

`;

export const ContainerHeaderGrid = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  padding-right: 10px;
  padding-left: 10px;
`;

export const AreaButtons = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  padding: 1rem;
`;
